import { render, staticRenderFns } from "./CommentTicket.vue?vue&type=template&id=7c9242d7&scoped=true"
import script from "./CommentTicket.vue?vue&type=script&lang=js"
export * from "./CommentTicket.vue?vue&type=script&lang=js"
import style0 from "./CommentTicket.vue?vue&type=style&index=0&id=7c9242d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9242d7",
  null
  
)

export default component.exports